<script lang="ts">
	import { Splide, SplideSlide as Slide, SplideTrack as Track } from '@splidejs/svelte-splide';
	import '@splidejs/splide/dist/css/splide.min.css';
	import __ from '$lib/stores/TranslationStore';
	import ArticleCard from './ArticleCard.svelte';
	import { dev } from '$app/environment';
	import { lazyLoad } from '$lib/actions/lazyLoad';
	import { PUBLIC_IMAGES_API } from '$env/static/public';
	import { toWebp } from '$lib/utils/helpers/convert';

	export const category: Category | null = null;

	export let articles: IndexArticle[];

	export let color: string = '';

	export let options: any = {
		autoplay: !dev,
		rewind: true,
		width: '100%',
		gap: '2.5rem',
		perPage: 1,
		pagination: true
	};

	const url = PUBLIC_IMAGES_API;
</script>

<div class={`bg-${color || 'primary'}`} data-sveltekit-reload>
	<Splide hasTrack={false} {options}>
		<div class="custom-wrapper bg-primary">
			<Track>
				{#each articles as article}
					{@const filename = toWebp(article.cover_name)}
					<Slide class="mt-[64px] lg:mt-0 lg:aspect-[14/4]">
						<div class="relative flex h-full w-full flex-col">
							<div
								class="overlay container mx-auto inline-block aspect-video from-black to-100% px-0 md:absolute md:top-0 md:max-w-none md:bg-gradient-to-r lg:top-0 lg:aspect-[14/4] xl:top-auto"
							>
								<img
									loading="lazy"
									class="relative -z-[1] aspect-video w-full object-cover lg:aspect-[14/4] lg:blur-[2px]"
									role="presentation"
									src="{url}/900/{filename}"
									srcset="
										{url}/200/{filename} 200w,
										{url}/300/{filename} 300w,
										{url}/400/{filename} 400w,
										{url}/500/{filename} 500w,
										{url}/600/{filename} 600w,
										{url}/700/{filename} 700w,
										{url}/800/{filename} 800w,
										{url}/900/{filename} 900w,
									"
									sizes="
										(max-width: 640px) 200px,
										(max-width: 768px) 300px,
										(max-width: 1024px) 400px,
										(max-width: 1280px) 800px,
										(max-width: 1536px) 900px,
										900px
									"
									alt={article.cover_alt || article.title}
								/>
							</div>
							<div
								class="container z-10 mx-auto flex grow flex-col items-stretch bg-slate py-12 text-white md:bg-transparent"
							>
								<ArticleCard
									imageLoading="eager"
									{article}
									class="flex grow flex-col before:absolute before:left-0 before:top-0 before:h-full before:w-full before:px-10 md:h-full md:grow-0 md:pl-8 md:pr-32 md:before:static md:before:grow md:before:basis-16 lg:before:basis-24 xl:w-4/6 xl:before:basis-36"
									titleClass="text-3xl font-bold"
									descriptionClass="line-clamp-2"
									light
									withoutCover
								>
									<footer slot="footer" let:article class="mt-auto">
										<p class="text-xs">
											<span class="read_duration"
												>{$__('Tempo de leitura: :minutes min.').replace(
													':minutes',
													article.read_duration
												)}</span
											>
										</p>
									</footer>
								</ArticleCard>
							</div>
						</div>
					</Slide>
				{/each}
			</Track>
		</div>
	</Splide>
</div>
